import { PortfolioViewState } from 'enums/PortfolioViewState'
import { Portfolio } from 'types'

import { paveApi } from 'api'
import PerformanceTooltipContent from 'components/partials/Portfolio/V2/TooltipContent/PerformanceTooltipContent'
import { ERROR_MESSAGE_1 } from 'constants/content.constants'
import PDSCard from 'designSystem/components/PDSCard/PDSCard'
import PDSCardHeader from 'designSystem/components/PDSCardHeader/PDSCardHeader'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSLink from 'designSystem/components/PDSLink/PDSLink'
import PDSText from 'designSystem/components/PDSText/PDSText'
import PDSTooltip from 'designSystem/components/PDSTooltip/PDSTooltip'
import PDSValueTag from 'designSystem/components/PDSValueTag/PDSValueTag'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { LINE_HEIGHT } from 'designSystem/foundations/constants/lineHeight'
import { SIZE } from 'designSystem/foundations/constants/size'
import { useCustomToast } from 'hooks/useCustomToast'
import { formatAsCurrency } from 'utils'
import {
  getIbUsername,
  getPortfolioViewState,
  isIbPortfolio,
} from 'utils/portfolioUtil'

type Props = {
  portfolio: Portfolio
}

export default function PortfolioPerformanceCard({ portfolio }: Props) {
  const { showErrorToast } = useCustomToast()

  const [getIbSsoSession] = paveApi.useGetIbSsoSessionMutation()

  const portfolioViewState = getPortfolioViewState(portfolio)
  const showCardContent = portfolioViewState === PortfolioViewState.NORMAL
  const showPerformanceLink = showCardContent && isIbPortfolio(portfolio)

  const seePerformance = () => {
    if (isIbPortfolio(portfolio)) {
      const username = getIbUsername(portfolio)
      if (username) {
        getIbSsoSession({ username: username })
          .unwrap()
          .then(({ ssoUrl }) => {
            window.open(ssoUrl, '_blank', 'noreferrer')
          })
          .catch(() => {
            showErrorToast(ERROR_MESSAGE_1)
          })
      } else {
        showErrorToast(ERROR_MESSAGE_1)
      }
    } else {
      showErrorToast(ERROR_MESSAGE_1)
    }
  }

  let content = null
  if (showCardContent) {
    content = (
      <PDSFlexBox alignItems="center" gap={SIZE.s8}>
        <PDSText
          fontSize={FONT_SIZE.lg}
          fontWeight="bold"
          lineHeight={LINE_HEIGHT.lh24}
        >
          {portfolio && formatAsCurrency(portfolio?.value)}
        </PDSText>
        <PDSValueTag value={portfolio?.performance} variant="arrow" />
        <PDSText color={COLOR.textSecondary} size="sm" weight="medium">
          Today
        </PDSText>
      </PDSFlexBox>
    )
  }

  return (
    <PDSCard>
      <PDSCardHeader>
        <PDSFlexBox alignItems="center" justifyContent="space-between">
          <PDSFlexBox alignItems="center" gap={SIZE.s8}>
            <PDSHeader variant="h4">Performance</PDSHeader>
            {isIbPortfolio(portfolio) && (
              <PDSTooltip content={<PerformanceTooltipContent />} />
            )}
          </PDSFlexBox>

          {showPerformanceLink && (
            <PDSLink
              href="#"
              onClick={seePerformance}
              text="See Full Performance"
              variant="secondary"
            />
          )}
        </PDSFlexBox>
      </PDSCardHeader>

      {content}
    </PDSCard>
  )
}
